import React from 'react';
import { StyledMoreCarouselButton, StyledMoreCarouselButtonWrapper } from '../Styled/StyledCarousel';
import { LeftArrowIcon, RightArrowIcon } from '../../assets/icons/Arrows';
import { CarouselButtonSide } from '../../types/assets';

interface ICarouselButton {
  iconSide: CarouselButtonSide;
  isDisabled: boolean;
  handleBtnClick: () => void;
}

export const CarouselButton = (props: ICarouselButton): JSX.Element => {
  const { iconSide, isDisabled, handleBtnClick } = props;

  return (
    <StyledMoreCarouselButtonWrapper icon={iconSide}>
      <StyledMoreCarouselButton
        onClick={handleBtnClick}
        isDisabled={isDisabled}
        tabIndex={isDisabled ? -1 : 0}
        aria-label={`${iconSide === CarouselButtonSide.left ? 'Previous carousel' : 'Next carousel'}`}
        data-testid={`carousel-${iconSide}-button`}
      >
        {iconSide === CarouselButtonSide.left ? <LeftArrowIcon /> : <RightArrowIcon />}
      </StyledMoreCarouselButton>
    </StyledMoreCarouselButtonWrapper>
  );
};
